document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', (event) => {
      // Récupère l'élément parent
      const parent = event.target.closest('.product-options-thumbnails');

      // Retire la classe 'selected' des autres miniatures
      parent.querySelectorAll('.variant-thumbnail').forEach(thumb => {
        thumb.classList.remove('selected');
      });

      // Ajoute la classe 'selected' à l'élément cliqué
      event.target.classList.add('selected');

      // Change l'image principale
      const newImage = event.target.getAttribute('data-image');
      const mainImage = event.target.closest('.product-card').querySelector('.product-card__image--primary');
      if (mainImage && newImage) {
        mainImage.src = newImage;
        mainImage.srcset = '';
      }
    });
  });
});
